'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024 from "./presto.types$-Two-Factor-Auth-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$62() {
  this.aHg = null;
  this.aHe = null;
  this.aHf = false;
  this.aHc = null;
  this.aHd = false;
  this.aHh = false;
  this.aHi = false;
  this.aHg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_CredentialsView$$anon$62 as $c_Lpresto_CredentialsView$$anon$62 };
$p = $c_Lpresto_CredentialsView$$anon$62.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$62;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$62() {
}
export { $h_Lpresto_CredentialsView$$anon$62 as $h_Lpresto_CredentialsView$$anon$62 };
$h_Lpresto_CredentialsView$$anon$62.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.aHg;
});
$p.t = (function() {
  if ((!this.aHf)) {
    this.aHe = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aHf = true;
  }
  return this.aHe;
});
$p.ad = (function() {
  if ((!this.aHd)) {
    this.aHc = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024.$m_Lpresto_types$TwoFactorAuthId$().vb(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aHd = true;
  }
  return this.aHc;
});
$p.v = (function() {
  if ((!this.aHi)) {
    this.aHh = false;
    this.aHi = true;
  }
  return this.aHh;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_CredentialsView$$anon$62 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$62, "presto.CredentialsView$$anon$62", ({
  Gr: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$62 as $d_Lpresto_CredentialsView$$anon$62 };
//# sourceMappingURL=presto.-Credentials-View$$anon$62.js.map
